import { ConfirmPopup, LegalDocument, ScrollArea, Text } from '~/commonComponents';
import { useToggle } from '~/hooks';
import { Colors } from '~/themes/colors';
import { TnCContents } from './Constants';

interface IProps {
  isOpen: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
}

export const TermsConditionAddendumPopup = ({ isLoading = false, isOpen, onConfirm }: IProps) => {
  const [isAtBottom, controls] = useToggle();

  if (!isOpen) {
    return null;
  }

  return (
    // @ts-expect-error - ConfirmPopup still written in Javascript
    <ConfirmPopup
      title={
        <Text bold color={Colors.primary_500} fontSize={24}>
          GoTu’s Terms Addendum for
          <br />
          Permanent Placement
        </Text>
      }
      titleStyle={{ alignSelf: 'flex-start', textAlign: 'left' }}
      modalStyle={{
        height: 590,
        width: 544,
        paddingBlock: 48,
        paddingInline: 76,
      }}
      rightButtonAction={onConfirm}
      rightButtonDisabled={!isAtBottom}
      rightButtonLoading={isLoading}
      rightButtonStyle={{ height: 48, width: 296, marginTop: 30, selfAlign: 'center' }}
      rightButtonText={isAtBottom ? 'I Agree, Post Job' : 'Scroll to Agree'}
    >
      <ScrollArea
        style={{
          flex: 1,
          paddingRight: 14,
          width: 'auto',
        }}
        onEndReached={controls.setOn}
      >
        <LegalDocument content={TnCContents} />
      </ScrollArea>
    </ConfirmPopup>
  );
};
